import { render, staticRenderFns } from "./empty-editor.vue?vue&type=template&id=3b75d99a&functional=true&"
import script from "./empty-editor.vue?vue&type=script&lang=js&"
export * from "./empty-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports